import React, { useRef, useState } from "react";
import Text, { Props } from "./Text";
import Editor from "./Editor";

interface TextProps extends Props {
  id: string;
  editor: boolean;
  onChange?: (value: any, id: string) => void;
  className?: any;
}

const Index = (props: TextProps) => {
  const [openEditor, setOpenEditor] = useState(false);
  const ref = useRef(null);

  const closeEditor = (event: any) => {
    const el: any = ref?.current;

    if (!el || el.contains(event.target as Node)) {
      return;
    }
    setOpenEditor(false);
  };
  if (props.editor) {
    return (
      <div
        ref={ref}
        onClick={() => setOpenEditor(true)}
        className={`hover:border hover:border-red-500 relative ${props.className}`}
      >
        <Editor
          openEditor={openEditor}
          onChange={props?.onChange}
          id={props.id}
          ref={ref}
          value={props?.children}
          setOpen={closeEditor}
        />
      </div>
    );
  }

  return <Text {...props} />;
};

export default Index;
